import React from 'react';
import Cleave from 'cleave.js/react';
import s from './InputCurrency.scss'
import { formatMoney } from '../../../utils';
import createValidator from '../Utils/createValidator';
import { oppositeCurrency } from '../../../utils';

const InputCurrency = ({
    currency,
    name,
    value,
    onCurrencyChange,
    onValueChange,
    cleaveOptions,
    min,
    max,
    placeholder,
    validate,
    autoFocus,
    className = '',
    app_type,
    addOn,
    values,
}) => (
    <div className={`${s.container} ${className}`}>
      {/*   {(name != 'requested' && app_type != 'CE') ?
            <select
                value={currency}
                name={`${name}_currency`}
                onChange={onCurrencyChange}
                className={s.select}
            >
                <option value="ARS">$</option>
                <option value="USD">U$D</option>
            </select>
            : null
        } */}
        {addOn && <span className={`${s.addOn} ${(name=='collateral') && s.addOnColl}`}>{addOn}</span>}
        <Cleave
            value={value}
            name={`${name}_value`}
            onChange={onValueChange}
            className={s.input}
            options={cleaveOptions}
            min={min}
            max={max}
            type="tel"
            onBlur={validate}
            autoFocus={autoFocus}
            placeholder={placeholder}
            currency={currency}
        />
    </div>
);

export default createValidator(InputCurrency);
